<template>
  <div
    :style="{
      backgroundColor: extras.meetingAgenda
        ? extras.meetingAgenda.bg
        : '#ffffff',
    }"
    class="m-schedule top-nav"
    v-if="extras.meetingAgenda.display == 1"
    id="meetingAgenda"
  >
    <WapTitle
      v-if="extras.meetingAgendaTitle.display == 1"
      :title="extras.meetingAgendaTitle.model || title"
      :icon="icon"
      :titleFont="extras.meetingAgendaTitle.color"
    />
    <!--swiper只有一项的时候 不居中-->
    <div class="tab swiper-container" v-if="agendas.length == 1">
      <div class="swiper-wrapper">
        <div
          class="date swiper-slide"
          v-for="(item, index) in agendas"
          :key="index"
        >
          <div class="date-cnt" @click="DayClick(item)">
            <span :class="{ active: item.agendaDate == currentId }">{{
              item.agendaDate | formatDate
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <swiper :options="swiperOptions" class="tab" v-if="agendas.length > 1">
      <swiper-slide
        class="date swiper-slide"
        v-for="(item, index) in agendas"
        :key="index"
      >
        <div class="date-cnt" @click="DayClick(item)">
          <span :class="{ active: item.agendaDate == currentId }">{{
            item.agendaDate | formatDate
          }}</span>
        </div>
      </swiper-slide>
    </swiper>
    <div
      class="m-tab-list"
      v-if="
        extras &&
        extras.subMeetingAgenda &&
        extras.subMeetingAgenda.display == 1
      "
      v-show="
        (agendasJson.itemsSubSeminar &&
          agendasJson.itemsSubSeminar.length > 0) ||
        isSetting == 1
      "
    >
      <div
        class="tab2"
        @click="changeAgendaType(0)"
        :class="{
          'cursor-default': isSetting == 1,
          active: agendaType === 0,
        }"
      >
        大会日程
      </div>
      <div
        class="tab2"
        @click="changeAgendaType(1)"
        :class="{
          'cursor-default': isSetting == 1,
          active: agendaType === 1,
        }"
      >
        分会场日程
      </div>
    </div>

    <ul class="tab-body" v-if="agendaType === 0 && agendasJson.items">
      <div class="line"></div>
      <li v-for="(field, index) in agendasJson.items" :key="index">
        <div class="list-top">
          <img src="@/assets/images/wap/time.png" alt="" />
          <span v-show="field.hidden != 1 || extras.mergeAgenda.display == 0">
            {{ field.startTime | formatTime }} -
            {{ field.endTime | formatTime }}
          </span>
        </div>
        <div class="list-bottom">
          <div class="title" v-html="field.name"></div>
          <div
            class="name"
            v-show="extras.AgendaRemark && extras.AgendaRemark.display == 1"
            v-html="field.remark"
          ></div>
          <!--          <div class="text">{{ field.address }}</div>-->
          <div class="name">{{ field.address }}</div>
          <div v-for="(guest, gindex) in field.guests" :key="gindex">
            <span class="text">{{ guest.name }}</span>
            <span class="" v-if="guest.enterprise">
              &nbsp;|&nbsp;{{ guest.enterprise }}
            </span>
            <span class="text" v-if="guest.duty">
              &nbsp;&nbsp;|&nbsp;{{ guest.duty }}
            </span>
          </div>
        </div>
      </li>
    </ul>
    <div
      class="tab-body-branch-venue"
      v-if="agendaType === 1 && agendasJson.itemsSubSeminar"
    >
      <div
        class="branch-venue-box"
        v-for="(field, index) in agendasJson.itemsSubSeminar"
        :key="index"
      >
        <div class="g-meeting-address">
          <div class="left1 u-mr10" v-if="field.subSeminarName">
            <img
              class="g-meeting-address-icon"
              src="../../assets/images/pc/seminar-name.png"
            />
            <span class="g-meeting-name">{{ field.subSeminarName }}</span>
          </div>
          <div class="left1" v-if="field.subSeminarAddress">
            <img
              class="g-meeting-address-icon"
              src="../../assets/images/pc/seminar-address.png"
            />
            <span class="g-meeting-address-text">{{
              field.subSeminarAddress
            }}</span>
          </div>
        </div>

        <ul class="tab-body" v-if="field.items.length > 0">
          <div class="line"></div>
          <li v-for="(field, index) in field.items" :key="index">
            <div class="list-top">
              <img src="@/assets/images/wap/time.png" alt="" />
              <span
                v-show="field.hidden != 1 || extras.mergeAgenda.display == 0"
              >
                {{ field.startTime | formatTime }} -
                {{ field.endTime | formatTime }}
              </span>
            </div>
            <div class="list-bottom">
              <div class="title" v-html="field.name"></div>
              <div
                class="name"
                v-show="extras.AgendaRemark && extras.AgendaRemark.display == 1"
                v-html="field.remark"
              ></div>
              <div class="name">{{ field.address }}</div>
              <div v-for="(guest, gindex) in field.guests" :key="gindex">
                <span class="text">{{ guest.name }}</span>

                <span class="" v-if="guest.enterprise">
                  &nbsp;|&nbsp;{{ guest.enterprise }}
                </span>
                <span class="text" v-if="guest.duty">
                  &nbsp;&nbsp;|&nbsp;{{ guest.duty }}
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="m-nodata-body u-mt0 u-mb0">
      <div
        class="m-nodata"
        v-if="
          agendaType === 0 &&
          agendasJson.items &&
          agendasJson.items.length === 0
        "
      >
        <img src="@/assets/images/nodata.png" />
        <div class="m-nodata">暂无数据</div>
      </div>
    </div>

    <div
      class="m-nodata-body"
      v-if="agendaType === 1 && agendasJson.itemsSubSeminar.length === 0"
    >
      <img src="@/assets/images/nodata.png" />
      <div class="m-nodata">暂无数据</div>
    </div>

    <div class="no-data" v-if="agendas.length == 0">
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
import WapTitle from "@/components/index/WapTitle.vue";
import { URLS } from "fire-wind-water";

export default {
  components: {
    WapTitle,
  },
  props: {
    agendas: [],
    extras: Object,
  },
  data() {
    return {
      num: 0,
      title: "会议日程",
      icon: require("@/assets/images/wap/huiyi.png"),
      isSetting: 0,
      agendaType: 0,
      currentId: "",
      agendasDates: [],
      agendasJson: [],
      swiperOptions: {
        slidesPerView: "3",
        grabCursor: true,
        setWrapperSize: true, //使用flexbox布局(display: flex)
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    if (this.agendas.length > 0) {
      this.agendasJson = this.formatAgendaJson(this.agendas[0]);
      this.agendasJson.itemsSubSeminar = this.agendas[0]
        ? this.formatSubSeminarAgendaJson(this.agendas[0].itemsSubSeminar)
        : [];
      this.currentId = this.agendas[0].agendaDate;
    }
  },
  methods: {
    changeAgendaType(type) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.agendaType = type;
    },
    DayClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      //this.num = index;
      console.log(item);
      this.agendaType = 0;
      this.agendasJson = this.formatAgendaJson(item);
      this.currentId = item.agendaDate;
    },
    formatAgendaJson(items) {
      // eslint-disable-next-line no-empty
      let agenda = [];
      for (let i = 0; i < items.items.length; i++) {
        let AgendaStr = this.getAgendaDate(
          items.items[i].startTime,
          items.items[i].endTime
        );
        if (agenda.indexOf(AgendaStr) !== -1) {
          items.items[i].hidden = 1;
        } else {
          agenda.push(AgendaStr);
          items.items[i].hidden = 0;
        }
      }

      if (items.itemsSubSeminar && items.itemsSubSeminar.length > 0) {
        items.itemsSubSeminar = this.formatSubSeminarAgenda(items);
      }

      return items;
    },

    formatSubSeminarAgenda(items) {
      for (let i = 0; i < items.itemsSubSeminar.length; i++) {
        items.itemsSubSeminar[i] = this.formatAgendaJson(
          items.itemsSubSeminar[i]
        );
      }
      return items.itemsSubSeminar;
    },
    formatSubSeminarAgendaJson(items) {
      // eslint-disable-next-line no-empty

      let agenda = [];
      for (let i = 0; i < items.length; i++) {
        let AgendaStr = this.getAgendaDate(
          items[i].subSeminarStartTime,
          items[i].subSeminarEndTime
        );
        if (agenda.indexOf(AgendaStr) !== -1) {
          items[i].hidden = 1;
        } else {
          agenda.push(AgendaStr);
          items[i].hidden = 0;
        }
      }
      return items;
    },
    getAgendaDate(startTime, endTime) {
      return startTime + "_" + endTime;
    },
  },
};
</script>
<style scoped>
/*.swiper-wrapper {*/
/*width: 300px;*/
/*}*/
</style>
